import { storeCreator } from '@/utils/store/store.utils';

interface VerificationModalState {
  email?: string;
  firstName?: string;
  lastName?: string;
}

interface State extends VerificationModalState {
  isVerificationModalVisible: boolean;
  openVerificationModal: (values: VerificationModalState) => void;
  resetVerificationModalStore: () => void;
}

export const useVerificationModalStore = storeCreator<State>((set) => ({
  isVerificationModalVisible: false,
  email: undefined,
  firstName: undefined,
  lastName: undefined,

  openVerificationModal: (values: VerificationModalState) => set(() => ({
    isVerificationModalVisible: true,
    email: values.email,
    firstName: values.firstName,
    lastName: values.lastName,
  })),

  resetVerificationModalStore: () => set(() => ({
    isVerificationModalVisible: false,
    email: undefined,
    firstName: undefined,
    lastName: undefined,
  })),
}));

export default useVerificationModalStore;
